import React from 'react'
import CustomDialog from '../../../../components/stateless/dialog/CustomDialog'
import DropDown from '../../../../components/stateless/dropDown/DropDown';
import TextField from '../../../../components/stateful/textField/TextField';
import './CreateDraftModal.scss';
import { useCreateDraftModalController } from './CreateDraftModalController';
import Checkbox from '../../../../components/stateless/checkbox/Checkbox';
import { Icon } from '@progress/kendo-react-common';

interface ICreateDraftModal {
  open: boolean;
  toggleDialog: () => void;
  title: string;
  cancelAction?: () => void;
  approveAction: (x: boolean) => void;
  updateDraft?: (draft: any, chapterData?: any) => void;
}
const CreateDraftModal = (props: ICreateDraftModal) => {
  const { open, title, toggleDialog, cancelAction, approveAction, updateDraft } = props;
  const {
    // redux
    titleList,
    chapterValues,
    agencyValues,
    workflowValues,
    // state
    selectedWorkflow,
    selectedAgency,
    selectedTitle,
    selectedChapter,
    createChapter,
    rulemakingActions,
    selectedAction,
    // functions
    handleTextFieldChange,
    onWorkflowSelect,
    onAgencySelect,
    onTitleSelect,
    onChapterSelect,
    toggleChapterCreate,
    sanitizeChapterList,
    onActionSelect,
  } = useCreateDraftModalController(updateDraft);

  return (
    <CustomDialog
      open={open}
      title={title}
      toggleDialog={toggleDialog}
      cancelAction={cancelAction}
      approveAction={() => {approveAction(createChapter)}}
    >
      <div className="create-draft-body">
        <div style={{color:'red'}}><i>* All fields are required.</i></div>
        <div><Icon name='question' /> <i>If you are creating a new chapter please save the chapter then select it from the dropdown.</i></div>
        <br />
        <TextField title="Draft Name" size="large" onChange={(data) => handleTextFieldChange(data)} />
        <div className='form-region'>
          <DropDown
            value={selectedWorkflow}
            label="Workflow"
            textField='workflowName'
            dataKey='id'
            listItems={workflowValues}
            size="large"
            onSelect={onWorkflowSelect}
          />
          <DropDown
            value={selectedAgency}
            label="Agency"
            textField='agencyName'
            dataKey='id'
            listItems={agencyValues}
            size="large"
            onSelect={onAgencySelect}
          />
          <DropDown
            value={selectedTitle}
            label="Title"
            textField='titleName'
            dataKey='id'
            listItems={titleList}
            size="large"
            onSelect={onTitleSelect}
            idName="titleNumber"
          />
          {selectedWorkflow?.id === 1 && !createChapter && (
            <DropDown
              value={selectedAction}
              label="Rulemaking Action"
              textField='filingActionName'
              dataKey='id'
              listItems={rulemakingActions}
              size='large'
              onSelect={onActionSelect}
            />
          )}
          <div className="create-draft-checkbox">
            <Checkbox
              label='Creating A New Chapter Y/N?' onClick={toggleChapterCreate}
            />
          </div>
          {/* TODO: Create chapter data can be removed from this it'll be handled in the proposedRule and proposedRuleHistory */}
          {createChapter ? (
            <></>
          ) : (
            <DropDown
              value={selectedChapter}
              label="Chapter"
              textField='chapterName'
              dataKey='id'
              listItems={sanitizeChapterList(chapterValues)}
              size="large"
              onSelect={onChapterSelect}
              idName="chapterNumber"
            />
          )}
        </div>
      </div>
    </CustomDialog>
  )
}

export default CreateDraftModal